export default __webpack_public_path__ + "static/media/no_image.dd71c595.jpg";